import { AxiosError } from "axios";
import { api } from "../../api/api";
import ComissaoEmailEnviado from "../../model/ComissaoEmailEnviado";

export default class ComissaoService {
    buscarEmailsEnviados() {
        return new Promise<ComissaoEmailEnviado[]>((resolve, reject): void => {
            api.get("/comissao/emails-enviados")
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }
}
